import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import * as classnames from 'classnames/bind';
import * as React from 'react';
import {NavLink} from 'react-router-dom';

const styles = require('./SearchButton.less');
const cx = classnames.bind(styles);

interface ISearchButtonProps
{
    className?:string;
}

export class SearchButton extends React.Component<ISearchButtonProps, any>
{
    public render()
    {
        return (
            <NavLink
                exact={true}
                to={paths.search()}
                className={cx(styles.searchLink, this.props.className)}
                activeClassName={styles.active}
            >
                <MDIcon
                    className={cx('searchIcon')}
                    name={MDIcons.common.Search}
                    size={MDIconSize.medium}
                />
            </NavLink>
        );
    }
}